// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__30Nlw","linkButtonContainer":"Link_linkButtonContainer__17iM_","linkButton":"Link_linkButton__Fshlw","linkSpinner":"Link_linkSpinner__1LLfi"};